<template>
	<div  class="m-1">
		<div class="container">
			<h2>Compact Material Scanner</h2>
			<div class="input-group input-group-lg ">
				<input type="text" class="form-control" placeholder="EAN" v-model="scannedEan">
				<div class="input-group-append">
					<button>
						<span class="icon icon-rocket"></span>
					</button>
				</div>
			</div>
			<hr>
				
				<font v-if="!_.some(orderData, (d) => { return d == null })" size="+2">
					<span class="row">letzte Bestellung</span>
					<div class="row">
						<div class="col-12" style="text-align: right;">
							{{orderData.orderTime}}					
						</div>
					</div>
					<div class="row ">
						<label class="col-4">Status</label>
						<div class="col-8" style="text-align: right;">
							{{orderStateTypes[orderData.state]}}					
						</div>
					</div>
					<div class="row ">
						<label class="col-4">Zielland</label>
						<div class="col-8" style="text-align: right;">
							{{orderData.customer.country}}					
						</div>
					</div>
					<div class="row ">
						<label class="col-4">Kunde</label>
						<div class="col-8" style="text-align: right;">
							{{orderData.customer.firstName + ' ' + orderData.customer.lastName}}					
						</div>
					</div>
					<div class="row ">
						<label class="col-4">VK</label>
						<div class="col-8" style="text-align: right;">
							{{(Number(orderData.articlePriceTotal)*Number(orderData.currencyToEuro)).toFixed(2)}}€					
						</div>
					</div>
					<div class="row ">
						<label class="col-4">Markt</label>
						<div class="col-8" style="text-align: right;">
							{{marketName}}		
						</div>
					</div>
				</font>			
			<div v-if="material != null">
				<hr>
				<hr>
				<table class="table table-sm table-hover">
					<thead>
						<tr>
							<th scope="col"><font size="+2">Lieferant</font></th>
							<th scope="col"><font size="+2">LK</font></th>

							<th scope="col"><font size="+2">EK€</font></th>
							<th scope="col"><font size="+2">Bsd.</font></th>
						</tr>
					</thead>
					<tbody>
							<tr v-for='(stock, stockIndex) in material.stocks' v-if='stock.quantity > 0'>
								<td><font size="+1"><strong>{{ stock.vendor.name }}</strong></font><span class="d-flex">{{stock.articleId }}</span></td>

								<td><font size="+2"><b>{{ stock.vendor.deliveryClass }}</b></font></td>

								<!--td>{{ stock.articleId }}</td-->
								
				

								<td><font size="+2">{{ Number(stock.purchasePrice).toFixed(2) }} 
									<span v-if="stock.articleCondition == 1" class="d-flex"> Neu</span>
									<span v-else-if="stock.articleCondition == 2" class="d-flex"> Gebraucht</span>
									<span v-else class="d-flex"> condition undefined</span>
								</font></td>

								<td><font size="+2">{{ stock.quantity }}</font></td>

								<!--td>{{ stock.sku }}</td-->

							</tr>

					</tbody>
				</table>
			</div>
			
		</div>
	</div>
</template>

<script>
	export default {
		props:['ean'],
		data() {
			return {
				scannedEan: this.ean,
				getDebouncedWrapper: null,
				marketAccounts: null,
				material: null,
				orderData: {
					state: null,
					orderTime: null,
					marketAccountId: null,
					articlePriceTotal: null,
					currencyToEuro: null,
					customer: {
						firstName: null,
						street: null,
						city: null,
						state: null,
						zipCode: null,
						country: null
					}
				},
				orderStateTypes: {
					"-2": "Status",
					"-1": "Offen",
					0: "Neu",
					1: "Erledigt",
					2: "Freigegeben",
					3: "Erstattet",
					4: "Erstattet & OM"
				},
				watchMarketAccountId: null,
				marketName: null
			}
		},

		watch: {
			scannedEan: function(eanNew, eanOld)
			{
				console.log('ean changed.');
				this.getDebounced();
			},

			watchMarketAccountId: function(idNew, idOld)
			{
				var dump = this.marketAccounts.find((m) => {return (m.id == this.orderData.marketAccountId);});
				this.marketName = 'unknown';
				if (dump != undefined && dump != null)
				{
					this.marketName = dump.market.name;
				}
			}
		},

		methods: {
			getDebounced: function () 
			{
				console.log('getDebounced called.');
				console.log('scannedEan: ' + this.scannedEan);
				if(this.scannedEan != undefined && this.scannedEan != null)
				{
					this.getDebouncedWrapper.call();
				}

			},

			/*
				get() {
					console.group('get()');
					this.scannedEan = 743219614391;
					axios.get('/customerorder/get/' + this.scannedEan, null)
						.catch( (error) => {
							console.log(error);
						})
						.then( (response) => {
							console.dir(response);

						});
					console.groupEnd();
				}
			*/	

		},

		created() {
			console.log('created called.');
			this.getDebouncedWrapper = _.debounce(
				() => {
					console.group('getDebouncedWrapper');
					//this.scannedEan = 743219614391;
					axios.get('/customerorder/getlastorder/' + this.scannedEan, null)
						.catch( (error) => {
							console.log(error);
						})
						.then( (response) => {
							this.orderData = response.data;
							this.watchMarketAccountId = this.orderData.marketAccountId;
							// +++ parse change Date
							let year	= response.data.orderTime.substring(0,4);
							let month	= response.data.orderTime.substring(5,7);
							let day		= response.data.orderTime.substring(8,10);
							let time	= response.data.orderTime.substring(11,20);
							this.orderData.orderTime = day + '.' + month + '.' + year + ', ' + time + ' Uhr';
						});
						axios.get('/material/exists', {params:{code: this.scannedEan}})
						.catch( (error) => {
							console.log(error);
						})
						.then( (request) => {
							var materialId = request.data;
							// +++ get actual material data, this will contain all stock-data we need.
							axios.get('/material/get', {params:{materialId: materialId}})
							.catch( (error) => {
								console.log(error);
							})
							.then( (request) => {
								console.log(request);
								this.material = request.data;

								for(let stock of this.material.stocks)
								{
									console.log(stock.vendor.name.length);
									if(stock.vendor.name.length > 10)
									{
										let left = stock.vendor.name.substring(0,4);
										let right = stock.vendor.name.substring(stock.vendor.name.length - 4, stock.vendor.name.length);
										stock.vendor.name = left + '..' + right;
									}
								}


							});
						});

					console.groupEnd();
				},
				250, //deboucnce: delay
				{maxWait:650} //debounce: modifiers
				)//debounce: end

		},

		mounted() {
			console.log('Compact Material Scanner mounted');

			axios.get('/marketaccount/all', null)
				.catch((error) => {
					console.log(error);
				})
				.then( (response) => {
					//console.log(response);
					this.marketAccounts = response.data;
				});
		}
	}
</script>